Ext.define('ViewZaladunki', {
    extend: 'Ext.panel.Panel',
    grid: null,
    gridpage: null,
    windowObject: null,
    id: "zaladunki",
    taskContextMenu: null,
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyName: "access.manage.zaladunki",
        accessPropertyViewName: "access.view.zaladunki",
        accessPropertyViewNameLimitOnly: "access.view.stany_limit_only"
    },
    cat: 't',
    text: Lang.zaladunki,
    buttonIconCls: "iconZaladunek",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy.capitalise(),
                scope: this,
                handler: this.dodajObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/add")
            }, {
                id: this.id + "bedit",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.edytuj.capitalise(),
                scope: this,
                handler: this.edytujObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/update")
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconPDF",
                text: Lang.pdf.capitalise(),
                scope: this,
                handler: this.getDownloadLsPdf
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEXCEL",
                text: Lang.excel.capitalise(),
                scope: this,
                handler: this.getDownloadLsExcel
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: "box",
                id: this.id + "kontekstfirmybox",
                cls: "kontekstfirmy-box"
            }, {
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                style: 'display:block;margin-right:5px;',
                cls: "kontekstfirmy-text"

            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
        if (this.grid && this.grid.rendered)
            this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        var kontekstfirmybox = Ext.getCmp(this.id + "kontekstfirmybox");
        if (AppFIRMACTX != null && !Const.AGGREGATEDCORE) {
            kontekstfirmybox.update("<div class='appSetColourRedSplit'></div>");
            kontekstfirmy.setText(Lang.pracujesz_w_kontekscie + AppFIRMACTX.nazwa);
        } else {
            kontekstfirmybox.update("");
            kontekstfirmy.setText("");
        }
        if (this.rebuildGrid) {
            this.rebuildGrid = false;
            var onwer = this.grid.ownerCt;
            Ext.suspendLayouts();
            onwer.remove(this.grid);
            this.grid.destroy();
            this.taskContextMenu.destroy();
            this.buildGrid();
            onwer.add(this.grid);
            Ext.resumeLayouts(true);
            if (this.grid && this.grid.rendered)
                this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        }
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
    },
    buildGrid: function () {
        var store = Ext.create('Ext.data.Store', {
            autoLoad: false,
            remoteSort: true,
            remoteFilter: true,
            pageSize: 50,
            fields: [{
                name: 'czas',
                mapping: 'czas',
                type: 'date'
            }, {
                name: 'ile',
                mapping: 'ile',
                type: 'float'
            }, {
                name: 'plyn',
                mapping: 'plyn'
            }, {
                name: 'stanzbiornika',
                mapping: 'stanzbiornika',
                type: 'float'
            }, {
                name: 'zbiornik',
                mapping: 'zbiornik'
            }, {
                name: 'pojazd',
                mapping: 'pojazd'
            }, {
                name: 'odbiorca',
                mapping: 'odbiorca'
            }, {
                name: 'dostawca',
                mapping: 'dostawca'
            }, {
                name: 'gestoscoperacji',
                mapping: 'gestoscoperacji'
            }, {
                name: 'gestoscsrednia',
                mapping: 'gestoscsrednia'
            }, {
                name: "userimienazwisko",
                mapping: "userimienazwisko"
            }, {
                name: 'kosztcalosc',
                mapping: 'kosztcalosc'
            }, {
                name: 'kosztlitr',
                mapping: 'kosztlitr'
            }, {
                name: 'stanzbiornikarealbefore',
                mapping: 'stanzbiornikarealbefore'
            }, {
                name: 'stanzbiornikareal',
                mapping: 'stanzbiornikareal'
            }, {
                name: 'stanzbiornikadelta',
                mapping: 'stanzbiornikadelta'
            }, {
                name: 'nefWorkingParametersAsString',
                mapping: 'nefWorkingParametersAsString'
            }, "opis", "miedzymagazynowe"],
            proxy: {
                type: "ajax",
                url: "rest/zaladunekkorekty/getList",
                filterParam: "filters",
                actionMethods: {
                    read: 'POST'
                },
                reader: {
                    type: 'json',
                    rootProperty: 'data',
                    totalProperty: 'total',
                    id: 'id'
                },
                extraParams: {
                    iskorekta: false
                },
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            sorters: {
                property: "czas",
                direction: "DESC"
            },
            listeners: {
                scope: this,
                load: handlGridLoadStoreCheckJsonRpcL
            }
        });
        var cols = [{
            header: Lang.czas,
            flex: 2,
            sortable: true,
            dataIndex: 'czas',
            renderer: Ext.util.Format.dateRenderer(),
            filter: {
                type: 'date'
            },
            filterable: true
        }, {
            header: Lang.zbiornik,
            flex: 2,
            sortable: true,
            dataIndex: 'zbiornik',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.pojazd,
            flex: 2,
            sortable: true,
            dataIndex: 'pojazd',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.odbiorca,
            flex: 2,
            sortable: true,
            dataIndex: 'odbiorca',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.dostawca,
            flex: 2,
            sortable: true,
            dataIndex: 'dostawca',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
        }, {
            header: Lang.opis,
            flex: 2,
            sortable: true,
            dataIndex: 'opis',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: Ext.getViewportWidth() <= 1366
        }, {
            header: Lang.plyn,
            flex: 2,
            sortable: true,
            dataIndex: 'plyn',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.gestosc,
            flex: 1,
            sortable: true,
            dataIndex: 'gestoscoperacji',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.roundToPrecision(v, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.gestosc_srednia,
            flex: 1,
            sortable: true,
            dataIndex: 'gestoscsrednia',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.roundToPrecision(v, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.zaladunek.capitalise(),
            flex: 1,
            sortable: true,
            dataIndex: 'ile',
            renderer: function (v) {
                return Ext.Number.roundToPrecision(v, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.stan_pozaladunku,
            flex: 1,
            sortable: true,
            dataIndex: 'stanzbiornika',
            renderer: function (v) {
                return Ext.Number.roundToPrecision(v, 3).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.operator,
            flex: 2,
            sortable: true,
            dataIndex: 'userimienazwisko',
            filter: {
                type: 'string'
            },
            filterable: true,
            hidden: Ext.getViewportWidth() <= 1366
        }, {
            header: Lang.koszt,
            width: 100,
            sortable: true,
            dataIndex: 'kosztcalosc',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.toFixed(v, 2).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            hidden: true,
            filterable: true
        }, {
            header: Lang.cena_jednostkowa,
            width: 100,
            sortable: true,
            dataIndex: 'kosztlitr',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.toFixed(v, 2).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            hidden: true,
            filterable: true
        }, {
            header: Lang.nef_params,
            width: 200,
            sortable: false,
            dataIndex: 'nefWorkingParametersAsString',
            hidden: true,
            filterable: true
        }, {
            header: Lang.stan_zbiornika_delta,
            width: 100,
            sortable: true,
            dataIndex: 'stanzbiornikadelta',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.toFixed(v, 2).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.stan_zbiornika_real,
            width: 100,
            sortable: true,
            dataIndex: 'stanzbiornikareal',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.toFixed(v, 2).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.stan_zbiornika_real_before,
            width: 100,
            sortable: true,
            dataIndex: 'stanzbiornikarealbefore',
            renderer: function (v) {
                if (v == null)
                    return null;
                return Ext.Number.toFixed(v, 2).toString().replace(".", Ext.DECIMAL_SEPARATOR);
            },
            filter: {
                type: 'numeric'
            },
            filterable: true
        }, {
            header: Lang.przesuniecie_miedzymagazynowe,
            width: 50,
            sortable: true,
            dataIndex: 'miedzymagazynowe',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true,
            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || Ext.getViewportWidth() <= 1440
        }];
        if (!validPrivilegesOperatorComplex(ViewSkpPomiary.accessPropertyViewName) || !(Const.ENTERPRISEFLAG || Const.PROFLAG || Const.OPTIMALFLAG)) {
            removeObjectFromArrayById(cols, "stanzbiornikarealbefore");
            removeObjectFromArrayById(cols, "stanzbiornikareal");
            removeObjectFromArrayById(cols, "stanzbiornikadelta");
        }
        if (Const.OPTIMALFLAG || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG) {
            removeObjectFromArrayById(cols, "pojazd");
            removeObjectFromArrayById(cols, "odbiorca");
        }
        if (Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG) {
            removeObjectFromArrayById(cols, "gestoscoperacji");
            removeObjectFromArrayById(cols, "gestoscsrednia");
            removeObjectFromArrayById(cols, "dostawca");
            removeObjectFromArrayById(cols, "miedzymagazynowe");
        }
        if (validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyViewNameLimitOnly) && isValidOperatorFirmaLimit()) {
            removeObjectFromArrayById(cols, "stanzbiornika");
        }
        if (!Const.COSTCOLUMNS) {
            removeObjectFromArrayById(cols, "kosztcalosc");
            removeObjectFromArrayById(cols, "kosztlitr");
        }
        if (!Const.ENABLENEFPROCESSING || AppOPERATORROLA != Const.OPERATOR_P_SERWIS) {
            removeObjectFromArrayById(cols, "nefWorkingParametersAsString");
        }
        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true
            },
            store: store,
            columns: cols,
            frame: false,
            border: false,
            stateId: "grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            },
            bbar: {
                xtype: 'pagingtoolbarexd',
                displayInfo: true,
                pagingStore: store
            }
        });
        this.grid.addListener("rowdblclick", function () {
            if (validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/update"))
                this.edytujObiekt();
        }, this);
        this.grid.addListener("render", function () {
            this.manageSelect(this.grid.getSelectionModel());
        }, this);
        this.grid.store.addListener("load", function () {
            updateCzasRefreshSerwer();
        }, this);
        this.grid.addListener("select", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.grid.addListener("selectionchange", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.taskContextMenu = new Ext.menu.Menu();
        this.taskContextMenu.add([{
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Lang.nowy.capitalise(),
            scope: this,
            handler: this.dodajObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/add")
        }, {
            id: this.id + "bedit2",
            iconAlign: 'left',
            iconCls: "iconEdit",
            text: Lang.edytuj.capitalise(),
            scope: this,
            handler: this.edytujObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/update")
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconPDF",
            text: Lang.pdf.capitalise(),
            scope: this,
            handler: this.getDownloadLsPdf
        }, {
            iconAlign: 'left',
            iconCls: "iconEXCEL",
            text: Lang.excel.capitalise(),
            scope: this,
            handler: this.getDownloadLsExcel
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconRefresh",
            text: Lang.odswiez.capitalise(),
            scope: this,
            handler: this.refreshDatastore
        }]);
        this.grid.addListener("rowcontextmenu", function (grid, record, tr, rowIndex, e) {
            this.rowContext = grid.getStore().getAt(rowIndex);
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
        this.taskContextMenu.addListener("hide", function () {
            this.rowContext = null;
        }, this);
        this.grid.addListener("containercontextmenu", function (grid, e) {
            this.rowContext = null;
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        var bedit2 = Ext.getCmp(this.id + "bedit2");
        if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null) {
            bedit.setDisabled(true);
        } else {
            var row = this.grid.getSelectionModel().getSelection()[0];
            bedit.setDisabled(!validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/update"));
        }
        if (this.rowContext == null) {
            bedit2.setDisabled(true);
        } else {
            bedit2.setDisabled(!validPrivilegesOperatorComplex(ViewZaladunki.accessPropertyName + "/update"));
        }
    },
    refreshDatastore: function () {
        this.grid.store.load();
    },
    getDownloadLsPdf: function () {
        var defd = this.grid.getDefGridQueryCSF();
        postFormAsync("rest/zaladunekkorekty/downloadExportPdfOtherList", {
            format: "pdf",
            iskorekta: false,
            name: Lang.zaladunek,
            filters: defd.filters,
            sort: defd.sorters,
            defd: Ext.encode(defd)
        }, null);
    },
    getDownloadLsExcel: function () {
        var defd = this.grid.getDefGridQueryCSF();
        postFormAsync("rest/zaladunekkorekty/downloadExportPdfOtherList", {
            format: "excel",
            iskorekta: false,
            name: Lang.zaladunek,
            filters: defd.filters,
            sort: defd.sorters,
            defd: Ext.encode(defd)
        }, null);
    },
    dodajObiekt: function () {
        var windowObject = Ext.create('WindowZaladunek', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(0);
    },
    edytujObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        var windowObject = Ext.create('WindowZaladunek', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        windowObject.showW(id);
    }
});
